import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./ScheduledFor.module.css";

type ScheduledForProps = {
  text: string;
};

function ScheduledFor({ text }: ScheduledForProps) {
  return (
    <FixaText data-testid="scheduled-for" className={styles["root"]}>
      {text}
    </FixaText>
  );
}

export default ScheduledFor;
